<template>
  <div class="device-detail-wrapper">
    <div class="item-device-detail">
      <div class="text-item">
        <div class="f-c-midgrey f-14 f-regular m-r-4">ID Device:</div>
        <div class="f-c-black f-14 f-regular m-r-4">{{ idDevice }}</div>
        <input type="hidden" id="id" :value="idDevice">
        <img src="@/assets/icons/copy-grey.svg" alt="" @click="copyText('id')">
      </div>
      <div class="text-item">
        <div class="f-c-midgrey f-14 f-regular m-r-4">Serial Number: </div>
        <div class="f-c-black f-14 f-regular m-r-4">{{ snapSerial ? snapSerial.serial : "-" }}</div>
        <template v-if="snapSerial">
          <input type="hidden" id="serial" :value="snapSerial.serial">
          <img src="@/assets/icons/copy-grey.svg" alt="" @click="copyText('serial')">
        </template>
      </div>
      <div class="text-item">
        <div class="f-c-midgrey f-14 f-regular m-r-4">Tarif (per transaksi):</div>
        <div class="f-c-black f-14 f-regular m-r-4">{{ tarif*100 }}%</div>
      </div>
    </div>
    <div class="item-device-detail">
      <div class="d-flex justify-content-between">
        <div class="text-item">
          <div class="f-c-midgrey f-14 f-regular m-r-4">Firmware:</div>
          <div class="f-c-black f-14 f-regular m-r-4 m-r-4">{{ firmWare }}</div>
          <div class="badge-grey f-regular f-c-midgrey f-14" v-if="firmWare < latVer">Update</div>
        </div>
        <div class="f-14 f-semi" :class="ol?'f-c-blue ':'f-c-midgrey'" v-if="firmWare < latVer">Download Update</div>
      </div>
    </div>
  </div>
</template>

<script>
import SOButton from "@/so-components/global/ui/SOButton";

export default {
  name: "SODeviceDetail",
  components: {SOButton},
  props: {
    idDevice: String,
    snapSerial: Object || Array,
    tarif: Number,
    firmWare: Number,
    latVer: Number,

    ol: Boolean
  },
  methods: {
    copyText(id) {
      let el = document.getElementById(id);
      el.setAttribute("type", "text");
      el.select();

      try {
        var successful = document.execCommand('copy');
        if (successful) {
          this.$toast.success("Berhasil disalin")
        } else {
          this.$toast.error("Gagal disalin")
        }
      } catch (err) {
        this.$toast.error("Gagal disalin")
      }

      el.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    }
  }
}
</script>

<style scoped>
.device-detail-wrapper {
  background-color: #FFFFFF;
}

.item-device-detail {
  padding: 12px 20px;
}

.item-device-detail:nth-child(2) {
  border-top: 1px solid #E0E0E0;
}

.text-item {
  display: flex;
}

.text-item:not(:nth-child(1)) {
  margin-top: 4px;
}

.badge-grey {
  background: #F2F5F7;
  border-radius: 3px;
  padding: 0 4px;
}
</style>